import { render, staticRenderFns } from "./SwapRequestsApproved.vue?vue&type=template&id=327e84a9"
import script from "./SwapRequestsApproved.vue?vue&type=script&lang=js"
export * from "./SwapRequestsApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports